module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_panel weui_panel_access"
  }, [(_vm.header && _vm.header.title) ? _c('div', {
    staticClass: "weui_panel_hd",
    domProps: {
      "innerHTML": _vm._s(_vm.header.title)
    },
    on: {
      "click": function($event) {
        _vm.$emit('on-click-header')
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("header"), _vm._v(" "), _c('div', {
    staticClass: "weui_panel_bd"
  }, [_c('div', {
    staticClass: "vux-card-content"
  }, [_vm._t("content")], 2)]), _vm._v(" "), (_vm.footer && _vm.footer.title) ? _c('a', {
    staticClass: "weui_panel_ft",
    attrs: {
      "href": "javascript:"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.footer.title)
    },
    on: {
      "click": _vm.onClickFooter
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("footer")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-4c877825!./~/.1.0.35@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./~/.2.0.17@vux/src/components/card/index.vue
// module id = 280
// module chunks = 2